import logo from '#base/assets/img/amgen-logo.png'
import { useStyles } from './footer.style'

export const Footer = function () {
  const classes = useStyles()

  return (
    <div className={classes.footer}>
      <div className={classes.logoAndCopyright}>
        <img src={logo} width={150} />
        <div className={classes.copyright}>
          © 2022 Amgen Inc. All Rights Reserved. USA-785-81938
        </div>
      </div>
      <div>Powered by <a href="https://www.targetrwe.com" className={classes.poweredLink} target="_blank" rel="noreferrer">Target RWE</a></div>
    </div>
  )
}
